import type { InvoiceFilter } from '@vy/types';
import { useFiltersParam as useFiltersParamBase } from '../../../hooks/search-params/use-filters-param';
import { INVOICES_FILTER_FIELDS } from '../InvoicesPage/invoices-page-utils/filter-fields-utils';

export function useFiltersParam() {
  return useFiltersParamBase<InvoiceFilter>('filters', INVOICES_FILTER_FIELDS);
}
